
export default {
    name: "DropzoneBase",
    /**
     * files-dropped: emits files that were dropped into the dropzone
     * highlight: fires if there is something dragged onto the dropzone
     *            can be used for styling
     */
    emits: ["files-dropped", "highlight"],
    props: {
        /** Disables highlighting and file dropping.
         * Does not remove eventlisteners, but skips preventDefault */
        disabled: {
            type: Boolean,
            default: false,
        },
        /** Disables overlay */
        noOverlay: {
            type: Boolean,
            default: false,
        },
        /** Disables highlighting animation */
        noHighlight: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        isHighlighted: false,
    }),
    watch: {
        disabled(newVal) {
            if (newVal === false) {
                this.$emit("highlight", false)
                this.isHighlighted = false
            }
        },
    },
    mounted() {
        // add event listeners
        const dropzoneAdd = this.$refs["dropzone"]?.addEventListener
        if (!dropzoneAdd) return
        ;["dragenter", "dragover", "dragleave", "drop"].forEach((eventName) => {
            dropzoneAdd(eventName, this.preventDefaults)
        })
        ;["dragenter", "dragover"].forEach((eventName) => {
            dropzoneAdd(eventName, this.setHighlighted, false)
        })
        ;["dragleave", "drop"].forEach((eventName) => {
            dropzoneAdd(eventName, this.setUnHighlighted, false)
        })
    },
    beforeDestroy() {
        // remove event listeners
        const dropzoneRemove = this.$refs["dropzone"]?.removeEventListener
        if (!dropzoneRemove) return
        ;["dragenter", "dragover", "dragleave", "drop"].forEach((eventName) => {
            dropzoneRemove(eventName, this.preventDefaults)
        })
        ;["dragenter", "dragover"].forEach((eventName) => {
            dropzoneRemove(eventName, this.setHighlighted, false)
        })
        ;["dragleave", "drop"].forEach((eventName) => {
            dropzoneRemove(eventName, this.setUnHighlighted, false)
        })
    },
    methods: {
        preventDefaults(e) {
            if (!this.disabled) {
                e.preventDefault()
                e.stopPropagation()
            }
        },
        onDrop(e) {
            if (!this.disabled) {
                this.$emit("files-dropped", e.dataTransfer.files)
            }
        },
        setHighlighted() {
            if (this.disabled || this.isHighlighted) return
            this.$emit("highlight", true)
            this.isHighlighted = true
        },
        setUnHighlighted() {
            if (this.disabled || !this.isHighlighted) return
            this.$emit("highlight", false)
            this.isHighlighted = false
        },
    },
}
